import {MapEnum} from "../../enums/MapEnum";
import {IMapEnumElement} from "../../enums/interface";

class UserRole extends MapEnum<IMapEnumElement>  {
    static EMPTY: IMapEnumElement = {id: 0, name: "Empty"};
    static SYSTEM_ADMIN: IMapEnumElement = {id: 1, name: "System Admin"};
    static APPLICATION_ADMIN: IMapEnumElement = {id: 2, name: "Application Admin"};
    static SUPERVISOR: IMapEnumElement = {id: 3, name: "Supervisor"};
    static USER: IMapEnumElement = {id: 4, name: "User"};

    static {
        this.createElement();
    }
    static Instance(): UserRole {
        return super.Instance();
    }
    public static InstanceWithValue(value:number): UserRole {
        return super.InstanceWithValue(value);
    }
    public static InstanceWithName(name:string): UserRole {
        return super.InstanceWithName(name);
    }
    public static InstanceWithFieldName(fieldName:string): UserRole {
        return super.InstanceWithFieldName(fieldName);
    }

}
export  default UserRole;